import Vue from 'vue'
import VueRouter from 'vue-router' 
import RegisterCCI from './components/RegisterCCI'
import Register from './components/Register'
import RegisterSME from './components/RegisterSME'
import Login from './components/Login'
import Home from './components/Home'
import MyProfile from './components/MyProfile'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as VeeValidate from 'vee-validate';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import AddComment from './components/AddComment'
import ForgotPassword from './components/ForgotPassword'
import ResetPassword from './components/ResetPassword'

Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(VueRouter);
/*Vue.use(VueReCaptcha, { siteKey: '6LeYLPkUAAAAAMvoti6EDoZPuRbtR4NYqGMoWIKp' })*/


const routes = [
  { path: '/', component: Home },
  { path: '/register/', component: Register },
  { path: '/register-as-cci/', component: RegisterCCI },
  { path: '/register-as-sme/', component: RegisterSME },
  { path: '/login/', component: Login },
  { path: '/my-profile/', component: MyProfile },
  { path: '/resources/add-a-comment', component: AddComment },
  { path: '/forgot-password', component: ForgotPassword },
  { path: '/forgot-password/reset-password', component: ResetPassword }
]


const router = new VueRouter({
  mode: 'history',
  routes
})


new Vue({
  router
}).$mount('#app')

Vue.directive('uppercase', {
  update(el) {
    el.value = el.value.toUpperCase()
  },
});


 




// WEBPACK FOOTER //
// ./src/main.js